@if (item && item.board) {
    <span class="item-link"
          [ngClass]="{
            'item-link-inline': inline,
            'item-link-personal-item': item.board.isPersonalBoard,
            'item-link-bold-code': useBoldItemCode,
        }">
        @if (showStatus || showPersonImageLink || item.board?.isArchived || !hideItemCode || showSummary) {
            <div class="d-flex align-items-center gap-1">
                <!-- The 2 icons should be centered aligned while the entire div and the rest will be baselined -->
                @if (showStatus) {
                    <span class="show-icon-on-print flex-shrink-0"
                          [ngClass]="itemStatusBadgeClass"
                          [adaptTooltip]="itemStatusTooltip"> </span>
                }
                @if (showPersonImageLink) {
                    <span class="text-break d-flex align-items-center justify-content-center"
                          data-test="item-link-summary">
                        <adapt-link-person [person]="item.assignee"
                                           [showImage]="true"
                                           [showText]="false"
                                           [imageSize]="'xs'"></adapt-link-person>
                    </span>
                }
                @if (item.board?.isArchived) {
                    <i class="fal fa-fw fa-archive me-1"
                       adaptTooltip="This action is within an archived board"></i>
                }
                @if (showDialogLink && !showSummary) {
                    <a (click)="openItem($event)"
                       class="item-code text-nowrap"
                       data-test="item-code"
                       [href]="itemUrl$ | async"
                       target="_blank">
                        {{ item!.code }}
                        @if (item!.board?.isPersonalBoard) {
                            <i class="fal fa-lock-alt"
                               aria-hidden="true"
                               adaptTooltip="Item is only visible to you"> </i>
                        } @else {
                            <adapt-team-private-icon [team]="item.board.team"></adapt-team-private-icon>
                        }
                    </a>
                }
                @if (!hideItemCode && (!showDialogLink || showSummary)) {
                    <span class="item-code text-nowrap"
                          data-test="item-code">
                        {{ item!.code }}
                        @if (item!.board?.isPersonalBoard) {
                            <i class="fal fa-lock-alt"
                               aria-hidden="true"
                               adaptTooltip="Item is only visible to you"> </i>
                        } @else {
                            <adapt-team-private-icon [team]="item.board.team"></adapt-team-private-icon>
                        }
                    </span>
                }
                @if (showSummary && item!.summary && !showDialogLink) {
                    <span class="text-break item-link-summary"
                          data-test="item-link-summary">
                        {{ item!.summary }}
                    </span>
                }
                @if (showSummary && item!.summary && showDialogLink) {
                    <a (click)="openItem($event)"
                       class="text-break item-link-summary"
                       data-test="item-link-summary"
                       [href]="itemUrl$ | async"
                       target="_blank">
                        {{ item!.summary }}
                    </a>
                }
            </div>
        }
    </span>
}
